import React, { useEffect, useState } from "react";
import { Link } from "gatsby"
import { Container, Row, Col, Tabs, Tab, Form, Button } from "react-bootstrap"
import SelectBox from "../../../SelectBox/SelectBox"
import _ from "lodash";
import { useContainerContext } from "../../../../store/ContainerContext";

const ServiceFilterList = (props) => {
    const category_name = props.category_name;
    const context = useContainerContext();
    const { filter_by_serv, all_insights } = context.state;
    const { FilterByCatDispatch, FilterByServiceDispatch } = context.actions;
    const [filter_data, setFilterData] = useState([]);

    // const { loading, error, data } = category_name && category_name != "videos" ? NewsAndInsight(category_name) : AllNewsAndInsightsCategories();
    useEffect(() => {
        var uniqueCatItem = [];
        var uniqueItem = [];
        var uniqueOptions = [];
        let newsAndInsights = []
        //console.log('landlords_resolr', all_insights, props.alias)
        if (all_insights && all_insights.length > 0) {
            newsAndInsights = all_insights;
            if (props.alias && props.alias != "landlord_resource_center") {
                newsAndInsights = newsAndInsights.filter((item) => {
                    const newsType = item.News_Type?.toLowerCase(); // Convert to lowercase once
                    return newsType?.includes(props.alias) || newsType === "all";
                });
            }
        }
        newsAndInsights.map((item, i) => {
            let catName = item?.news_and_insights_category?.Name;
            if (catName && uniqueCatItem.indexOf(catName) === -1) {
                uniqueCatItem.push(catName)
                uniqueOptions.push({ catgeory: catName, department: [] })
            }
            if (item?.insight_departments && item?.insight_departments.length > 0) {
                item?.insight_departments.map((dItem, i) => {
                    let trim_item = dItem?.Name.trim();
                    //  if (uniqueItem.indexOf(trim_item) === -1) {
                    //  uniqueItem.push(trim_item); 
                    let itemData = uniqueOptions.find((dat) => dat.catgeory == catName)

                    if (itemData) {
                        itemData.department.push(trim_item);
                    }

                    //  }
                });

            }
        })
        // uniqueOptions.sort((a,b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
        setFilterData(uniqueOptions);
    }, [filter_by_serv, all_insights]);

    return (
        <React.Fragment>
            {
                filter_data.length > 0 &&
                <div className="category-select services">
                    <h4>Explore by category</h4>
                    {filter_data && filter_data.map((item, k) => {
                        //if (item.department.length > 0) {
                        return (
                            <div className={`cat_list ${(item.catgeory === category_name || category_name == "") ? 'd-block' : 'd-none'}`} >
                                <div className="title pointer" key={k}
                                    onClick={(e) => {
                                        props.FilterByDispatch(item.catgeory);
                                        props.FilterByDispatchSer("all")
                                    }}
                                >{item.catgeory}</div>

                                <div className="depart">
                                    {item.department && item.department.length > 0 && _.uniq(item.department).map((dep, i) => {
                                        return (
                                            <span className="tags" key={i} onClick={() => { props.FilterByDispatchSer(dep) }}>{dep}</span>
                                        )
                                    })}
                                </div>

                            </div>
                        )
                        //}
                    })}
                </div>
            }

        </React.Fragment >
    );
};
export default ServiceFilterList;
